import {
    trackEvent,
    trackEcommerce,
    type EcomTypeValues,
    type EventNameValues,
    trackingConstants,
    eventNameConstants,
} from 'dibs-tracking';

const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { EVENT_VIEW_ITEM_LIST } = eventNameConstants;

type Item = {
    serviceId: string | null;
    contemporaryTrackingString: string;
    title: string | null;
    browseUrl: string | null;
    categoryCode: string | null;
    seller: {
        serviceId: string | null;
    } | null;
} | null;

type Items = readonly Item[];

const trackInteraction = ({ action, label }: { action: string; label: string }): void => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

const trackCarouselItems = ({
    type,
    items,
    startIndex,
    variant,
    actionLabel,
    eventName,
}: {
    type: EcomTypeValues;
    items: Items;
    startIndex: number;
    variant: string;
    actionLabel: string;
    eventName: EventNameValues;
}): void => {
    const actionField = {
        list: `${actionLabel} carousel`,
        ...(type === ECOM_PRODUCT_CLICK ? { itemId: items?.[0]?.serviceId } : {}),
    };

    trackEcommerce({
        type,
        eventName,
        actionField,
        products: items.map((item: Item, index: number) => ({
            brand: item?.seller?.serviceId,
            category: item?.browseUrl,
            categoryCode: item?.categoryCode,
            id: item?.serviceId,
            variant,
            name: item?.title,
            list: `${actionLabel} carousel`,
            dimension83: item?.contemporaryTrackingString,
            position: startIndex + index,
        })),
    });
};

export const trackInitialDisplay = ({
    itemsReturned,
    actionLabel,
}: {
    itemsReturned: number;
    actionLabel: string;
}): void => {
    trackInteraction({
        action: `${actionLabel} items displayed`,
        label: itemsReturned.toString(),
    });
};

export const trackArrowClick = ({
    direction,
    actionLabel,
}: {
    direction: string;
    actionLabel: string;
}): void => {
    trackInteraction({
        action: `${actionLabel} items arrow clicked`,
        label: direction,
    });
};

export const trackImpressions = ({
    visibleItems,
    index,
    actionLabel,
}: {
    visibleItems: Items;
    index: number;
    actionLabel: string;
}): void => {
    trackCarouselItems({
        actionLabel,
        type: ECOM_PRODUCT_IMPRESSION,
        items: visibleItems,
        startIndex: index + 1, // Tracking needs non zero index position.
        variant: 'homepage',
        eventName: EVENT_VIEW_ITEM_LIST,
    });
};
